import {QuestionModelV3} from '@albert-io/models';
import {List} from 'immutable';
import React from 'react';
import SimpleMarkdown from 'simple-markdown';

import FillInTheBlankQuestionStore from 'client/components/QuestionTypes/FillInTheBlank/FillInTheBlankQuestion.store';
import {makeParser} from 'generic/MarkdownRendererV2/markdownRendererUtils';

import FitbDropdown from './FitbDropdown';

interface DropdownRendererProps {
  text: string;
  store: FillInTheBlankQuestionStore;
  dropdowns: List<any>;
  isExplanation: boolean;
  question: QuestionModelV3;
  isGuessSubmitted: boolean;
}

const DropdownRenderer = ({
  text,
  store,
  dropdowns,
  isExplanation,
  question,
  isGuessSubmitted
}: DropdownRendererProps) => {
  const createDropdownElement = (dropdownContent) => {
    if (!dropdownContent) {
      return null;
    }

    const dropdownId = dropdownContent.getId();

    return (
      <FitbDropdown
        key={dropdownId}
        choices={dropdownContent.getChoices()}
        dropdownId={dropdownId}
        store={store}
        isGuessSubmitted={isGuessSubmitted}
        isExplanation={isExplanation}
        question={question}
      />
    );
  };

  let dropdownIndex = 0;

  const dropdownRule = {
    order: SimpleMarkdown.defaultRules.em.order - 0.5,
    match: (source) => {
      return /^{{(dropdown)}}/.exec(source);
    },
    parse: (capture, parse, state) => {
      return {
        content: parse(capture[1], state)
      };
    },
    react: () => {
      const dropdown = createDropdownElement(dropdowns.get(dropdownIndex));
      dropdownIndex = dropdownIndex !== dropdowns.size - 1 ? dropdownIndex + 1 : 0;
      return dropdown;
    }
  };

  const parser = makeParser({dropdown: dropdownRule});
  const syntaxTree = parser.makeSyntaxTree(text);
  return <>{parser.reactOutput(syntaxTree)}</>;
};

export default DropdownRenderer;
